import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/marketing/back-in-stock/')({});
